import { Validator } from 'vee-validate'

const dict = {
  custom: {
    amount: {
      required: 'Please enter a donation amount',
      min_value: 'Please enter at least $1 or more'
    },
    cardNumber: {
      required: 'Please enter a credit / debit card number',
      credit_card: 'Please enter a valid card number'
    },
    expiration: {
      required: 'Please enter your card\'s expiration date',
      min: 'Please enter a valid expiration date'
    },
    cvc: {
      required: 'Please enter your card\'s CVC code',
      min: 'Your CVC code should be 3 or 4 numbers'
    },
    fullName: {
      required: 'Please enter your full name'
    },
    email: {
      required: 'Please enter an email address',
      email: 'Please enter a valid email address'
    }
  }
}

Validator.localize('en', dict)


// WEBPACK FOOTER //
// ./src/validation.js